import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { InputText, Button } from '../components'
import { trpc } from '../trpc'
import { mapAuthError } from '../lib/authErrors'
import { LOGIN_PATH } from '../lib/routes'
import styles from './RequestPasswordResetPage.module.scss'

export const RequestPasswordResetPage = (): React.ReactElement => {
  const [email, setEmail] = useState('')
  const [done, setDone] = useState(false)

  // The response is one fixed shape and carries nothing to show. It used to
  // carry the reset token outside production, which this page displayed for
  // testers; the token now leaves through the server LOG instead, so the
  // browser never receives a live credential and this component no longer has
  // to probe the payload at runtime to find out which environment it is in.
  const mutation = trpc.auth.requestPasswordReset.useMutation({
    onSuccess: () => {
      setDone(true)
    },
  })

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault()
    mutation.mutate({ email })
  }

  return (
    <div className={`row-flx flx-a-c flx-j-c p-24 bg-light-cream ${styles['request-password-reset-page']}`}>
      <div className={`p-v-40 p-h-32 border-s bg-white full-width ${styles['request-password-reset-page__card']}`}>
        <h1 className={`m-b-16 txt-kale ${styles['request-password-reset-page__heading']}`}>Recuperar contraseña</h1>

        {done ? (
          <div>
            <p className={`m-b-8 txt-light-kale ${styles['request-password-reset-page__info']}`}>
              Si existe una cuenta con ese email, recibirás las instrucciones en breve.
            </p>
            <div className="txt-a-c m-t-16">
              <Link to={LOGIN_PATH} className={`txt-olive txt-underline ${styles['request-password-reset-page__back-link']}`}>
                Volver al login
              </Link>
            </div>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="col-flx flx-gap-16" noValidate>
            <p className={`m-b-8 txt-light-kale ${styles['request-password-reset-page__info']}`}>
              Introduce tu email y te enviaremos las instrucciones para restablecer tu contraseña.
            </p>

            <InputText
              label="Email"
              type="email"
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              autoComplete="email"
              required
            />

            {mutation.isError && (
              <p role="alert" className={`m-0 txt-grana ${styles['request-password-reset-page__error']}`}>
                {mapAuthError(mutation.error, 'requestReset')}
              </p>
            )}

            <Button
              type="submit"
              variant="pill"
              label={mutation.isPending ? 'Enviando…' : 'Enviar instrucciones'}
              bgColor="olive"
              txtColor="white"
              disabled={mutation.isPending}
              className="full-width"
            />

            <div className="txt-a-c m-t-16">
              <Link to={LOGIN_PATH} className={`txt-olive txt-underline ${styles['request-password-reset-page__back-link']}`}>
                Volver al login
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  )
}
